import { RequestService } from '@tcc-online/request-service';
import ProjectAdminType from '../types/ProjectAdminType';
import SortParams from '../types/SortParams';

const AdminProjectAdminsService = {
    getAdmins,
    createAdmin,
    updateAdmin,
};

const createUrl = (params: {
    productType: number;
    projectId: number;
    adminId?: number;
}) => {
    const { productType, projectId, adminId } = params;
    let url = `/admin/products/${productType}/projects/${projectId}/admins`;
    if (adminId !== null && adminId !== undefined) {
        url += `/${adminId}`;
    }

    return url;
};

export interface BasePayload {
    productType: number;
    projectId: number;
}

async function getAdmins(
    payload: BasePayload & { limit?: number } & SortParams,
) {
    const { productType, projectId, limit, sortBy, sortOrder } = payload;
    return await RequestService.get<ProjectAdminType[]>(
        createUrl({ productType, projectId }),
        { sortBy, sortOrder, limit },
    );
}

interface CreateSettings {
    type: number;
    notificationSetting: number;
}

export type CreatePayload = CreateSettings &
    ({ userId: number; email?: never } | { email: string; userId?: never });

async function createAdmin(payload: CreatePayload & BasePayload) {
    const { productType, projectId, type, notificationSetting } = payload;
    const user =
        payload.email !== undefined
            ? { email: payload.email }
            : { userId: payload.userId };

    return await RequestService.post<CreatePayload, ProjectAdminType>(
        createUrl({ productType, projectId }),
        { ...user, type, notificationSetting },
    );
}

export interface UpdatePayload {
    type?: number;
    notificationSetting?: number;
}

async function updateAdmin(
    payload: UpdatePayload & BasePayload & { adminId: number },
) {
    const { productType, projectId, adminId, type, notificationSetting } =
        payload;
    return await RequestService.patch<UpdatePayload, ProjectAdminType>(
        createUrl({ productType, projectId, adminId }),
        { type, notificationSetting },
    );
}

export default AdminProjectAdminsService;
